module.exports = __webpack_public_path__ + "img/copyright.1b3e55b2.png";